import { render, staticRenderFns } from "./StartConversationButton.vue?vue&type=template&id=7076c228&scoped=true&"
import script from "./StartConversationButton.vue?vue&type=script&lang=js&"
export * from "./StartConversationButton.vue?vue&type=script&lang=js&"
import style0 from "./StartConversationButton.vue?vue&type=style&index=0&id=7076c228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076c228",
  null
  
)

/* custom blocks */
import block0 from "./StartConversationButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports